// extracted by mini-css-extract-plugin
module.exports = {"arrow":"_3D2fjFZY1dbT3wW-N5i5ze","down":"_21soIiXMupRAACCV0VJj_E","left":"_2o_ZiuSIUaTZnmA_U9PZrv","right":"_1rxZh1ruN7_UQnZZ4OVL4i"};